import React, { useRef } from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    CardGroup,
    Button
} from 'reactstrap';


function EmbeddedPage({ element }) {
    const {
        label="",
        url=""
    } = element;

    const cardBodyRef = useRef(null);

    const goFullscreen = () => {
        const cardBody = cardBodyRef.current;
        if (cardBody) {
            if (cardBody.requestFullscreen) {
                cardBody.requestFullscreen();
            } else if (cardBody.mozRequestFullScreen) { // Firefox
                cardBody.mozRequestFullScreen();
            } else if (cardBody.webkitRequestFullscreen) { // Chrome, Safari and Opera
                cardBody.webkitRequestFullscreen();
            } else if (cardBody.msRequestFullscreen) { // IE/Edge
                cardBody.msRequestFullscreen();
            } else {
                alert("Fullscreen API is not supported in this browser.");
            }
        }
    };

    if (!url) {
        return <div className="text-red-500">No URL provided</div>;
    }
    return (
        <CardGroup>
            <Card className="inbox-card primary no-bottom-gap">
                {label?(<CardHeader>
                    <span className="title">{label}</span>
                    <Button className="btn btn-primary float-right" size="sm" onClick={goFullscreen}>
                        Fullscreen
                    </Button>
                </CardHeader>):(<div>
                    <Button color="primary" className="btn float-right" size="sm" onClick={goFullscreen}>
                        Fullscreen
                    </Button>
                </div>)}
                
                <CardBody style={{ height: '80vh', padding:'0' }}>
                    <div
                        ref={cardBodyRef}
                        className="w-100 h-100 rounded-xl overflow-hidden shadow-md"
                    >
                        <iframe
                            src={url}
                            title="Embedded Page"
                            className="w-100 h-100 border-0"
                            allowFullScreen
                        />
                    </div>
                </CardBody>
            </Card>
        </CardGroup>
        
        
    );
}


EmbeddedPage.rootSchema = {
    "properties": {
        "label": {
            "title": "Label",
            "type": "string",
            "map:field": "label"
        },
        "url": {
            "title": "Url",
            "type": "string",
            "map:field": "url"
        }
    }
}

export default EmbeddedPage;